/**
 * CloudMap Constants
 * Static configuration values and map styles
 */

// Provider colors - style-based, not from database
export const PROVIDER_COLORS = {
    'aws': '#FF9900',
    'azure': '#0078D4',
    'gcp': '#EA4335',
    'google': '#EA4335',
};

export const DEFAULT_COLOR = '#666666';

// Super regions for quick zoom
export const SUPER_REGIONS = [
    {name: 'World', center: {lat: 20, lng: 0}, zoom: 2},
    {name: 'Americas', center: {lat: 15, lng: -90}, zoom: 3},
    {name: 'Europe', center: {lat: 50, lng: 10}, zoom: 4},
    {name: 'Asia Pacific', center: {lat: 20, lng: 115}, zoom: 3},
    {name: 'Middle East', center: {lat: 25, lng: 45}, zoom: 4},
    {name: 'Africa', center: {lat: 0, lng: 20}, zoom: 3},
];

/**
 * Get provider color by slug
 */
export function getProviderColor(slug) {
    const key = slug?.toLowerCase();
    return PROVIDER_COLORS[key] || DEFAULT_COLOR;
}

/**
 * Snazzy Maps styling for the map
 */
export function getMapStyles() {
    return [
        {
            "stylers": [
                {"hue": "#2c3e50"},
                {"saturation": 250}
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {"lightness": 50},
                {"visibility": "simplified"}
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
                {"visibility": "off"}
            ]
        }
    ];
}
